<div class="ui-modal">
    <div class="header flex-row space-between-center">
        {{ 'DATABASE_TAGS.EDIT_MODAL.TITLE'|translate }}
        <span class="ui-icon-close c-p"
              mat-dialog-close></span>
    </div>

    <div class="body">
        <div class="flex-col">
            <app-form [nameInputValue]="data.name"
                      [colorInputValue]="data.color"
                      [isShownInLeftPanelInputValue]="data.isShownInLeftPanel"
                      [isEdit]="true">
            </app-form>
        </div>
    </div>

    <div class="footer flex-row end-center">
        <ui-button [loading]="selectIsSaving()"
                   [disabled]="formComponent()?.form.invalid"
                   [text]="'COMMON.SAVE' | translate"
                   (clickAction)="save()">
        </ui-button>
    </div>
</div>